import SDiagonalArrow from "@public/image/icon/diagonal-arrow.svg";
import { cva, VariantProps } from "class-variance-authority";
import NextLink from "next/link";
import { ComponentProps } from "react";
import { cn } from "@/utils/cn";

interface LinkProps extends ComponentProps<typeof NextLink>, VariantProps<typeof linkVariants> {
  text: string;
}

const linkVariants = cva("flex items-center gap-1 fill-gray text-gray transition-colors hover:fill-primary hover:text-primary", {
  variants: {
    size: {
      default: "text-18 [&_svg]:size-5",
      sm: "text-16 [&_svg]:size-4",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

function Link({ text, size, className, ...props }: LinkProps) {
  return (
    <NextLink className={cn(linkVariants({ size }), className)} {...props}>
      <span>{text}</span>
      <SDiagonalArrow />
    </NextLink>
  );
}

export default Link;
